import { buildQueryString } from '../../lib/query-params.ts';
import { apiClient } from '../client.ts';
import type {
  DomainCertificate,
  DomainCertificateRenewal,
  DomainCertificateSurface,
  PaginatedResponse,
  RefreshDomainCertificatesResult,
} from '../types.ts';

export interface ListDomainCertificatesParams {
  page?: number;
  pageSize?: number;
  q?: string;
  expiringDays?: number;
  renewal?: DomainCertificateRenewal | string;
  surface?: DomainCertificateSurface | string;
  serverId?: string;
}

export async function listDomainCertificates(
  params?: ListDomainCertificatesParams,
): Promise<PaginatedResponse<DomainCertificate>> {
  return apiClient.get<PaginatedResponse<DomainCertificate>>(
    `/domain-certificates${buildQueryString(params)}`,
  );
}

export async function getDomainCertificate(idOrDomain: string): Promise<DomainCertificate> {
  return apiClient.get<DomainCertificate>(
    `/domain-certificates/${encodeURIComponent(idOrDomain)}`,
  );
}

export async function refreshDomainCertificates(params?: {
  domain?: string;
}): Promise<RefreshDomainCertificatesResult> {
  return apiClient.post<RefreshDomainCertificatesResult>(
    '/domain-certificates/refresh',
    params ?? {},
  );
}

export interface EnableManagedDomainCertificateInput {
  domain?: string;
  serverId: string;
  certPath: string;
  keyPath: string;
  siteId?: string;
}

export async function enableManagedDomainCertificate(
  idOrDomain: string,
  input: EnableManagedDomainCertificateInput,
): Promise<DomainCertificate> {
  return apiClient.post<DomainCertificate>(
    `/domain-certificates/${encodeURIComponent(idOrDomain)}/enable-managed`,
    input,
  );
}

export async function disableManagedDomainCertificate(
  idOrDomain: string,
): Promise<DomainCertificate> {
  return apiClient.post<DomainCertificate>(
    `/domain-certificates/${encodeURIComponent(idOrDomain)}/disable-managed`,
    {},
  );
}

export async function renewDomainCertificate(
  idOrDomain: string,
  params?: { force?: boolean },
): Promise<DomainCertificate> {
  return apiClient.post<DomainCertificate>(
    `/domain-certificates/${encodeURIComponent(idOrDomain)}/renew`,
    params ?? {},
  );
}
